import { useContext } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { RumComponentContext } from './rumComponentContext.js';

/**
 * A hook that allows tracking of actions in Real User Monitoring (RUM).
 * It automatically adds the component chain/breadcrumbs from <RumComponentContextProvider>.
 * You can add a "purpose" to the custom attributes to group the actions.
 *
 * @function
 * @param purpose - Explains the use case for the action. This allows for splitting performance and user-tracking actions, for example.
 *
 * @returns - A function that tracks a RUM action. Calls made before RUM is initialized are buffered by the SDK.
 */
export const useRumAction = (purpose = 'unknown') => {
  const componentContext = useContext(RumComponentContext);

  return (name: string, customAttributes?: object) => {
    datadogRum.addAction(name, {
      purpose,
      ...componentContext.customAttributes,
      ...customAttributes,
      react: {
        breadcrumbs: componentContext.componentBreadCrumbs,
        ...(customAttributes as any)?.react,
      },
    });
  };
};
